import React from 'react';

import { ContentStatus } from '@addmile/backend-client';

import { useContentQueries } from '../services/ContentManagerService';
import CreateCollectionForm from './CollectionsList/CreateCollectionForm';

interface EditCollectionViewProps {
  collectionSlug: string;
  onBack: () => void;
  onSaveSuccess: () => void;
}

export const EditCollectionView: React.FC<EditCollectionViewProps> = ({
  collectionSlug,
  onBack,
  onSaveSuccess,
}) => {
  const { useCollectionDetails } = useContentQueries();
  const { data: editCollection } = useCollectionDetails(collectionSlug, undefined, undefined);

  const initial = editCollection
    ? {
        slug: editCollection.slug,
        color: editCollection.color,
        title: editCollection.title,
        imageUrl: editCollection.imageUrl,
        status: editCollection.status as ContentStatus,
        personalization: editCollection.personalization,
        language: editCollection.language,
      }
    : undefined;

  return (
    <div className="max-w-[944px] p-6 rounded-2xl bg-white rounded-xl shadow-sm bg-white-100 p-6">
      <CreateCollectionForm onCancel={onBack} onSaved={onSaveSuccess} initial={initial} />
    </div>
  );
};

export default EditCollectionView;
